import { isEmpty } from './index'
import $vue from '@/main.js'


export const required = (value, msg) => {
  return (value && value.toString().length ? true : msg)
}

// 描述
export const descpReg = value => {
  if (isEmpty(value)) {
    return true
  }
  return value.length <= 255 || '支持0-255个字符'
}

// 邮箱
export const emailValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (Array.isArray(value)) {
    return value.every(val => re.test(String(val)))
  }

  return re.test(String(value)) || $vue.$t("account.email.emailError")
}

// 密码
export const passwordValidator = password => {
  if (password && (password.length < 6 || password.length > 24)) {
    return ('密码长度6-24位，请确认密码长度')
  }
  
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/
  const validPassword = regExp.test(password)
  return (
    validPassword ||
    '密码必须包含大小写字母和数字，如Abcd1234'
  )
}

// 确认密码
export const pwdConfirmValidator = (pwd, pwdConfirm) => {
  if (pwd != pwdConfirm) {
    return '两次密码输入不一致，请重新输入！'
  } else {
    return true
  }
}

// 手机号
export const phoneReg = (value, msg) => {
  if (isEmpty(value)) {
    return true
  }
  
  let re = /^[1][3,4,5,7,8,9][0-9]{9}$/;
  
  return re.test(String(value)) || '手机号格式错误'
}

export const confirmedValidator = (value, target) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  value === target || 'The Confirm Password field confirmation does not match'

export const between = (value, min, max) => () => {
  const valueAsNumber = Number(value)

  return (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) || `Enter number between ${min} and ${max}`
}

export const integerValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(val => /^-?[0-9]+$/.test(String(val)))
  }

  return /^-?[0-9]+$/.test(String(value)) || 'This field must be an integer'
}

export const regexValidator = (value, regex) => {
  if (isEmpty(value)) {
    return true
  }

  let regeX = regex
  if (typeof regeX === 'string') {
    regeX = new RegExp(regeX)
  }

  if (Array.isArray(value)) {
    return value.every(val => regexValidator(val, { regeX }))
  }

  return regeX.test(String(value)) || 'The Regex field format is invalid'
}

export const alphaValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  // const valueAsString = String(value)

  return /^[A-Z]*$/i.test(String(value)) || 'The Alpha field may only contain alphabetic characters'
}

export const urlValidator = value => {
  if (value === undefined || value === null || value.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/

  return re.test(value) || 'URL is invalid'
}

export const lengthValidator = (value, length) => {
  if (isEmpty(value)) {
    return true
  }

  return value.length === length || `The Min Character field must be at least ${length} characters`
}
export const alphaDashValidator = value => {
  if (isEmpty(value)) {
    return true
  }

  const valueAsString = String(value)

  return /^[0-9A-Z_-]*$/i.test(valueAsString) || 'All Character is not valid'
}

// 应用管理-地址校验
export const domainName = value => {
  // const ipCheck = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/    

  // 校验域名
  const domainCheck = /^[a-zA-Z][-a-zA-Z]{0,32}(\.[a-zA-Z][-a-zA-Z]{0,32})+$/
  
  return (isIP(value) || domainCheck.test(value)) || '请输入正确的域名或ip'
}

// 校验ip
const isIP = (strIP) => {
  var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/g 
  if(re.test(strIP)) {
    if( RegExp.$1 <256 && RegExp.$2<256 && RegExp.$3<256 && RegExp.$4<256) return true;
  }
  return false;
}

// 校验端口号
export const portNumber = (value) => {
  if (isEmpty(value)) {
    return true
  }

  let portReg = /^[1-9]\d*$/
   
  return (portReg.test(value) && 1 <= 1 * value && 1 * value <= 65535) || "请输入正确的端口号"
}

// 地址后缀校验
export const domainSuffixReg = (value) => {
  if (isEmpty(value)) {
    return true
  }
   
  return value.indexOf(" ") < 0 || "地址后缀不能包含空格"
}


/******** 用户列表 *******/
// 用户名
export const userName = value => {
  if (isEmpty(value)) {
    return true
  }

  let userNameReg = /^[\u4E00-\u9FA5A-Za-z0-9!@#$%^&*()_.=+-]{1,32}$/
  
  return userNameReg.test(value) || '支持1-32位字符，支持数字、中文、大小写字母，以及特殊字符!@#$%^&*()_.-=+'
}

// 用户组名称
export const userGroupName = value => {
  if (isEmpty(value)) {
    return true
  }

  let userNameReg = /^[\u4E00-\u9FA5A-Za-z0-9_-]{1,32}$/
  for (let item of value) {
    // 判断是手动添加还是选择，手动无id
    if (!item.id) {
      if (!userNameReg.test(item)) {
        return  '支持1-32位，支持汉字、数字、字母和-_中一种或多种组合'
      }
    }
  }

  return true
}


/******** 企业管理员 ********/
// 用户名
export const adminName = value => {
  if (isEmpty(value)) {
    return true
  }

  let adminNameReg = /^[\u4E00-\u9FA5A-Za-z0-9_·]{4,16}$/

  return  adminNameReg.test(value) || '支持4-16位字符，支持汉字、字母、数字、·或下划线的一种或多种组合'
}


/******** 管理员角色 ********/
// 角色名称
export const roleNames = value => {
  if (isEmpty(value)) {
    return true
  }

  let roleNameReg = /^[\u4E00-\u9FA5A-Za-z0-9_]{4,64}$/

  return roleNameReg.test(value) || '支持4-64位字符，支持汉字、字母、数字和下划线其中的一种或多种组合'
}



/******** 应用管理 ********/

//应用列表-名称
export const managementName = value => {
  if (isEmpty(value)) {
    return true
  }

  let mgNameReg = /^[\u4E00-\u9FA5A-Za-z0-9-]{1,32}$/

  return mgNameReg.test(value) || '支持1-32位字符，支持汉字、字母、数字、- 的一种或多种组合'
}

// 应用策略-名称
export const strategyName = value => {
  if (isEmpty(value)) {
    return true
  }
  
  var fBlank =/^\S+/ // 校验开头不能有空格
  var lBlank =/\S+$/  // 校验结尾不能有空格

  if(!fBlank.test(value) || !lBlank.test(value)) {
    return "请检查输入内容，首尾不可为空格! "
  }

  return value.length <= 128 || '支持1-128位字符'
}


/******** 边缘路由器 ********/
export const edgeName = value => {
  if (isEmpty(value)) {
    return true
  }
  let mgNameReg = /^[A-Za-z0-9]{1,32}$/

  return mgNameReg.test(value) || '1-32位，支持数字和大小写字母'
}